import { compareVersions } from './version';
import { isAppPrivacyReleased } from './appPrivacyRelease';

export const MIN_APP_PRIVACY_VERSION = '1.0.9';

// A cached manifest/runtime version cannot prove that this installation contains
// the required native binary. Use the current bridge reply and native version.
export function supportsAppPrivacy(runtimeInfo = window.__APP_RUNTIME_INFO) {
    const version = runtimeInfo?.nativeAppVersion;
    return Boolean(window.ReactNativeWebView
        && ['ios', 'android'].includes(runtimeInfo?.platform)
        && typeof version === 'string' && /^\d+\.\d+\.\d+$/.test(version)
        && version.split('.').map(Number).every(Number.isSafeInteger)
        && compareVersions(version, MIN_APP_PRIVACY_VERSION) >= 0
        && runtimeInfo?.capabilities?.appPrivacy === true);
}

export function shouldShowAppPrivacy(runtimeInfo = window.__APP_RUNTIME_INFO) {
    const platform = runtimeInfo?.platform || window.NATIVE_PLATFORM;
    return Boolean(window.ReactNativeWebView
        && ['ios', 'android'].includes(platform)
        && (supportsAppPrivacy(runtimeInfo) || isAppPrivacyReleased(platform)));
}
